import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {
	ChatMessage,
	ChatSessionStatus,
} from "../../../../services/treatmentPlan.service";

export const chatStatusLabel: Record<ChatSessionStatus, string> = {
	AWAITING_INPUT: "Waiting for your reply",
	IN_PROGRESS: "Thinking…",
	READY_TO_GENERATE: "Ready to generate",
	FAILED: "Last turn failed",
};

export const chatStatusColor: Record<
	ChatSessionStatus,
	"default" | "info" | "success" | "error" | "warning"
> = {
	AWAITING_INPUT: "default",
	IN_PROGRESS: "info",
	READY_TO_GENERATE: "success",
	FAILED: "error",
};

/** One turn in a design conversation. Shared by both assistants. */
export const ChatMessageBubble: React.FC<{ msg: ChatMessage }> = ({ msg }) => {
	const isUser = msg.role === "USER";
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: isUser ? "flex-end" : "flex-start",
				mb: 1,
			}}
		>
			<Paper
				variant="outlined"
				sx={{
					px: 1.5,
					py: 1,
					maxWidth: "85%",
					bgcolor: isUser ? "primary.light" : "background.paper",
					color: isUser ? "primary.contrastText" : "text.primary",
					borderColor: isUser ? "primary.main" : "divider",
					whiteSpace: "pre-wrap",
				}}
			>
				<Typography variant="body2">{msg.content}</Typography>
			</Paper>
		</Box>
	);
};

export default ChatMessageBubble;
